import { m } from "framer-motion";

import { styled } from "@mui/material/styles";
import { Button, Typography, Container, Box } from "@mui/material";
import { MotionContainer, varBounce } from "components/animate";
import useAuth from "hooks/useAuth";
import Logo from "components/logo";
import { useTranslation } from "react-i18next";

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: "70%",
  maxHeight: "30%",
  margin: "auto",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  backgroundColor: "white",
}));

export default function Error401Page() {
  const { triggerLogout } = useAuth();
  const { t: translate } = useTranslation();
  document.body.style.backgroundColor = "#F4F6F8";
  return (
    <Container component={MotionContainer}>
      <ContentStyle
        sx={{
          textAlign: "center",
          alignItems: "center",
          marginTop: "6%",
          paddingTop: "30px",
          paddingBottom: "30px",
          borderRadius: "16px",
        }}
      >
        <m.div variants={varBounce().in}>
          <Logo disabledLink sx={{ ml: -20, mb: 6, width: 64, height: 64 }} />
        </m.div>
        <m.div variants={varBounce().in} style={{ marginBottom: 15 }}>
          <Typography variant="h2" sx={{ px: 5, mt: 2, mb: 2 }}>
            401: {translate("authorization_required")}
          </Typography>
          <Typography variant="body1" sx={{ color: "text.primary", mt: 2 }}>
            {translate("error_401_text_1")}
          </Typography>
          <Typography variant="body1" sx={{ color: "text.primary", mb: 2 }}>
            {translate("error_401_text_2")}
          </Typography>
        </m.div>
        <Box sx={{ mb: 5 }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
            <Box sx={{ flexShrink: 0 }}>
              <Button
                size="large"
                variant="outlined"
                onClick={async () => {
                  await triggerLogout();
                }}
                sx={{
                  mx: 3,
                  pr: 4,
                  textTransform: "none",
                  color: "text.primary",
                  borderColor: "grey.300",
                  "&:hover": {
                    color: "text.primary",
                    borderColor: "grey.900",
                  },
                }}
              >
                {translate("go_to_otelier")}
              </Button>
              <Button
                size="large"
                variant="outlined"
                onClick={() => {
                  window.location.replace("https://launch2landing.mydigitaloffice.com/index.html");
                }}
                sx={{
                  backgroundColor: "text.primary",
                  textTransform: "none",
                  color: "white",
                  "&:hover": {
                    color: "black",
                    borderColor: "grey.900",
                  },
                }}
              >
                {translate("go_to_platform")}
              </Button>
            </Box>
          </Box>
        </Box>
        <m.div>
          <Typography variant="body2" sx={{ color: "text.primary", mb: 2 }}>
            {"\u00A9"} 2024 Otelier. {translate("all_reserved")}
          </Typography>
        </m.div>
      </ContentStyle>
    </Container>
  );
}
